import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import UserService from '../services/UserService'
import router from '../router'

const state = {
  lastOperation: "",
  lastOperationSuccess: false,
  lastOperationFailure: false,
  lastOperationMessage: "",
  lastOperationDateTime: new Date(),
  operationInProgress: false,
  statusHistory: []
}

const getters = {
  operationInProgress(state) { return state.operationInProgress },
  lastOperation(state) { return state.lastOperation },
  lastOperationSuccess(state) { return state.lastOperationSuccess },
  lastOperationFailure(state) { return state.lastOperationFailure },
  lastOperationMessage(state) { return state.lastOperationMessage },
  lastOperationDateTime(state) { return moment(state.lastOperationDateTime).format("YYYY-MM-DD HH:mm:ss") }
}

const mutations = {
  initialize(state) {
      Vue.set(state, 'lastOperation', "")
      Vue.set(state, 'lastOperationMessage', "")
      Vue.set(state, 'operationInProgress', false)
      Vue.set(state, 'lastOperationSuccess', false)
      Vue.set(state, 'lastOperationFailure', false)
      Vue.set(state, 'statusHistory', [])

  },
  setOperationInProgress(state, inProgress) {
    Vue.set(state, 'operationInProgress', inProgress)
  },
  setLastOperation(state, lastOperation) {
    Vue.set(state, 'lastOperation', lastOperation)
  },
  setLastOperationSuccess(state, lastOperationSuccess) {
    Vue.set(state, 'lastOperationSuccess', lastOperationSuccess)
  },
  setLastOperationFailure(state, lastOperationFailure) {
    Vue.set(state, 'lastOperationFailure', lastOperationFailure)
  },
  setLastOperationMessage(state, lastOperationMessage) {
    Vue.set(state, 'lastOperationMessage', lastOperationMessage)
  },
  setLastOperationDateTime(state, lastOperationDateTime) {
    Vue.set(state, 'lastOperationDateTime', lastOperationDateTime)
  },
  appendToHistory(state, status) {
    state.statusHistory.push(status)
  }
}

const actions = {
  initialize({commit}) {
    commit('initialize')
  },
  setStatus({ commit, state, dispatch }, {inProgress, operation, success, failure, message, exception, data, logAction}) {
    commit('setOperationInProgress', inProgress)
    commit('setLastOperation', operation)
    commit('setLastOperationSuccess', success)
    commit('setLastOperationFailure', failure)
    commit('setLastOperationMessage', message)
    commit('setLastOperationDateTime', new Date())
    commit('appendToHistory', {inProgress, operation, success, failure, message, exception, data, lastOperationDateTime: state.lastOperationDateTime})

    if (logAction) {

      dispatch('logActivity', {
        action: logAction,
        appId: 'cpm-admin',
        view: router.currentRoute.name,
        tab: '',
        url: window.location.href,
        source: router.currentRoute.path,
        data: message || operation
      })
    }
  },
  async logActivity({rootGetters}, activity) {

    var headers = {
      orgId: rootGetters['user/getOrgId'],
      userId: rootGetters['user/getUserId'],
      userName: rootGetters['user/getName'],
      userEmail: rootGetters['user/getLoginName'],
      orgContext: (rootGetters['user/getOrgContext'] || rootGetters['user/getOrgId']),
    }

    var objActivity = Object.assign({}, activity, headers)

    await UserService.logActivity(objActivity)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}